import { computed } from 'vue';
/**
 *
 * @param containerHeight Height of the skeleton container in pixels
 * @param skeletonItemHeight Height of each skeleton item (card) including margins in pixels
 */
export function useSkeletonComposable(containerHeight, skeletonItemHeight) {
    /**
     * Calculate number of skeleton items to show during loading
     * This ensures filling the entire container height with skeleton items
     */
    const skeletonCount = computed(() => {
        return Math.ceil(containerHeight / skeletonItemHeight);
    });
    return { skeletonCount };
}
